import {Component, Prop, Vue} from "vue-property-decorator";
import {UserModule} from "@/store/modules/user";
import {Loading} from "element-ui";
import {updMessageReviewUserByMessageReviewId} from "@/api/message";
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class TransferCommon extends Vue {
    @Prop() visible: false
    @Prop() id: ''

    disBtn = false
    userId = '' // 转交人Id
    opinion = '' // 转交理由


    created() {
        // console.log('this.id', this.id)
    }

    // computed
    get userList() {
        return UserModule.userList
    }

    /*
    * methods*/
    closeTransferTxtDialog() {
        this.$emit('handleClose', false)
    }

    confirmTransferTxtDialog() {
        if(!this.userId) {
            this.$message.error('请选择转交人')
            return
        }
        const obj = {
            messageReviewId: Number(this.id),
            opinion: this.opinion,
            userId: this.userId,
        }
        this.disBtn = true;
        const loading = Loading.service({
            text: `审批转交中，请稍后`
        })
        updMessageReviewUserByMessageReviewId(delNullProperty(obj) ).then(() => {
            this.$emit('doConfirm', false)
            this.$message.success('审批转交成功')
            this.opinion = ''
            this.userId = ''
            loading.close();
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
            this.disBtn = false;
        })
    }

    changeUsers(e){
        this.userId = e.id
    }
}
